import script from "./PoweredByEddySection.vue?vue&type=script&setup=true&lang=js"
export * from "./PoweredByEddySection.vue?vue&type=script&setup=true&lang=js"

import "./PoweredByEddySection.vue?vue&type=style&index=0&id=3db22435&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3db22435"]])

export default __exports__